"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncCommandPoller = void 0;
const debug_1 = __importDefault(require("debug"));
const core_1 = require("@integro/core");
const log = (0, debug_1.default)('itp:integro.helpers.AsyncCommandPoller');
const OP_READ_ASYNC_COMMAND = 'read_async_command';
const POLL_INTERVAL = 1000;
class AsyncCommandPoller {
    app;
    poller;
    data;
    error;
    isPending = false;
    isCompleted = false;
    isRunning = false;
    isErrored = false;
    onError;
    onCompleted;
    constructor(app, onError = null, onCompleted = null) {
        this.app = app;
        this.data = null;
        this.error = null;
        this.onError = onError;
        this.onCompleted = onCompleted;
    }
    begin(job) {
        this.isRunning = true;
        Promise.resolve(job)
            .then(d => this.init(d))
            .catch(err => this.updateState(null, err));
    }
    stop() {
        this.poller?.stop();
    }
    init(data) {
        this.poller = new core_1.Poller({
            name: 'AsyncCommandPoller',
            callback: this.pollerCallback.bind(this),
            interval: POLL_INTERVAL,
            errback: err => this.onError && this.onError(err)
        });
        this.updateState(data, null);
        log('polling started');
    }
    async fetchCommand(id) {
        return this.app.connections
            .request(OP_READ_ASYNC_COMMAND, {
            parameters: { id }
        })
            .then(resp => resp.data);
    }
    async pollerCallback() {
        try {
            const data = await this.fetchCommand(this.data.id);
            return this.updateState(data, null);
        }
        catch (err) {
            return this.updateState(null, err);
        }
    }
    updateState(data, error = null) {
        try {
            let statusChanged = (!this.data && data) ||
                (this.data && data && this.data.status !== data.status);
            if (data) {
                this.data = data;
                this.isPending = data.status === 'pending';
                this.isCompleted = data.status === 'completed';
            }
            this.setErrorStates(error, data);
            if (this.isPending && this.poller) {
                this.poller.start();
            }
            if (this.isRunning && !this.poller.isRunning) {
                this.poller.start();
            }
            if (this.isCompleted && statusChanged) {
                this.complete();
            }
            if ((this.isCompleted || this.isErrored) &&
                this.poller &&
                this.poller.isRunning) {
                this.poller.stop();
            }
            log('state changed data: %o, error: %o, downloader: %o', this.data, error, this);
        }
        catch (err) {
            this.setErrorStates(err);
            if (this.onError) {
                this.onError(err);
            }
            console.error(err);
        }
        if (this.isErrored) {
            return false;
        }
    }
    setErrorStates(error, data = null) {
        if (error) {
            this.error = error;
            this.isErrored = true;
            this.isRunning = false;
        }
        else {
            this.error = null;
            this.isErrored = null;
        }
        if (data && data.status === 'errored') {
            this.error = data.result || 'n/a';
            this.isErrored = true;
            this.isRunning = false;
        }
        if (this.isErrored && this.onError) {
            this.onError(this.error);
        }
    }
    complete() {
        this.isPending = false;
        this.isCompleted = true;
        this.isRunning = false;
        this.isErrored = false;
        this.error = null;
        if (this.onCompleted) {
            this.onCompleted(this.data);
        }
    }
}
exports.AsyncCommandPoller = AsyncCommandPoller;
